import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import SmsTemplateForm from "./components/SmsTemplateForm";

import {
  useGetSmsTemplateDetailQuery,
  useUpdateSmsTemplateMutation,
} from "store/services/smsTemplateApi";

import { useAppMeta } from "hooks";

const SmsTemplateEditScreen = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "SMS Templates", path: "/app/crm/sms-templates/list" },
    { title: "Edit SMS Template" },
  ];

  // RTK Query
  const {
    data: smsTemplateDetail,
    isLoading: loadingSmsTemplate,
    error,
  } = useGetSmsTemplateDetailQuery(id);

  const [updateSmsTemplate, { isLoading: updatingSmsTemplate }] =
    useUpdateSmsTemplateMutation();

  // Update handler
  const handleUpdateSmsTemplate = async (data) => {
    const payload = { id, ...data };

    try {
      await updateSmsTemplate(payload).unwrap();
      toast.success("SMS Template successfully updated!");
      navigate(`/app/crm/sms-templates/${id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't update SMS Template!"
      );
    }
  };

  useAppMeta("Edit SMS Template");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingSmsTemplate || updatingSmsTemplate}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <SmsTemplateForm
          isBusy={loadingSmsTemplate || updatingSmsTemplate}
          smsTemplateDetail={smsTemplateDetail}
          onSubmit={handleUpdateSmsTemplate}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default SmsTemplateEditScreen;